import http from "@/http"

export default {
  index(context) {
    return new Promise((resolve, reject) => {
      context.state.docs = []
      context.state.totalDocs = 0
      context.state.loading = true
      http
        .post(`/request/misc/index`, {
          search: context.state.search,
          limit: context.state.limit,
          page: context.state.page,
          role: context.state.role,
          active: context.state.active,
          sort: context.state.sort,
          filter: context.state.filter
        })
        .then((response) => {
          context.state.loading = false
          context.state.docs = response.data.docs
          context.state.totalDocs = response.data.totalDocs
          context.state.totalPages = response.data.totalPages
          resolve(response)
        })
        .catch((error) => {
          context.state.loading = false
          reject(error)
        })
    })
  },
  show(context, id) {
    return new Promise((resolve, reject) => {
      context.state.loading = true
      http
        .get(`/request/misc/show/${id}`)
        .then((response) => {
          context.state.loading = false
          resolve(response)
        })
        .catch((error) => {
          context.state.loading = false
          reject(error)
        })
    })
  },
  store(context, misc) {
    return new Promise((resolve, reject) => {
      context.state.loading = true
      http
        .post(`/request/misc/store/${misc.engineer._id}`, misc)
        .then((response) => {
          context.state.loading = false
          resolve(response)
        })
        .catch((error) => {
          context.state.loading = false
          reject(error)
        })
    })
  },
  update(context, misc) {
    return new Promise((resolve, reject) => {
      context.state.loading = true
      http
        .post(`/request/misc/update/${misc._id}`, misc)
        .then((response) => {
          context.state.loading = false
          resolve(response)
        })
        .catch((error) => {
          context.state.loading = false
          reject(error)
        })
    })
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      http
        .get(`/request/misc/delete/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
